import { useCurrentUserQuery } from '@/shared/legacy/hooks/useCurrentUserQuery';
import { useGetSchedulerConfigQuery } from '../api';
import { InterviewType } from '../model';
import { useNylasCalendarInterviewType } from './nylas-calendar.store';

export const useSelectedMethodHasMissingFields = () => {
  const interviewType = useNylasCalendarInterviewType();
  const { data: schedulerConfig } = useGetSchedulerConfigQuery();
  const { data: currentUser } = useCurrentUserQuery();

  if (!schedulerConfig || !currentUser) return false;

  const phone = currentUser.phone_number ?? '';

  if (interviewType === InterviewType.InPerson) {
    const address = schedulerConfig[InterviewType.InPerson]?.address ?? '';
    return !address || !phone;
  }

  if (interviewType === InterviewType.Call) {
    return !phone;
  }

  return false;
};
